import React from "react";
import { Container } from "react-bootstrap";
import maintenanceImg from "../Assets/images/under-maintenance.gif";
import { automatedServerRoute } from "../../../../utils/Constant";
import "./UnderMaintenance.css";

const UnderMaintenance = () => {
  const text = `Under Maintenance${window.location.href.includes(automatedServerRoute) ? " (Send Reports)" : ""}!`;
  return (
    <Container>
      <div className="mb-5 UnderMaintenance__Container">
        <div className="text-center">
          <img src={maintenanceImg} alt="under_maintenance" width={450} />
        </div>
        <div className="text-center m-auto">
          <h3 className="text-blue font-weight-bold">
            {text}
          </h3>
        </div>
      </div>
    </Container>
  );
};

export default UnderMaintenance;
